/** The UI consumes the authoritative decision without duplicating fiscal rules. */
export const canShowReturnAction = (eligibility: { eligible: boolean }) => eligibility.eligible;

export const validateReturnQuantity = (quantity: string, availableQuantity: string) => {
  const requested = Number(quantity);
  const available = Number(availableQuantity);
  if (!Number.isFinite(requested) || requested <= 0) return 'La cantidad debe ser mayor que cero.';
  if (!Number.isFinite(available) || requested > available) return 'La cantidad supera el saldo retornable.';
  return undefined;
};
